import React, { useEffect, useState } from "react";
import ElementSelectionDialog from "./ElementSelectionDialog";
import { useTranslation } from "react-i18next";
import moment from "moment";

import CustomTabs from "../../components/Tab";
import InputBox from "../../components/InputBox";
import Dropdown from "../../components/Dropdown";
import DupontDatePicker from "../../components/DatePopover/DupontDatePicker";
import { DatePickerConfig } from "../../components/DatePopover/DateTimeConfig";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import DupontCheckbox from "../../components/DupontCheckbox";
import WPDropdown from "../../packages/WPDropdown";
import WPInput from "../../packages/WPInput";
import {
  STAGE_DEFAULTS,
  TECHNOLOGIES,
} from "../../constants/global.constants.js";
import CustomModal from "../../packages/CustomModal";
import DupontRadio from "../../components/DupontRadio";
import WPTertiaryButton from "../../packages/WPTertiaryButton";

import "./index.scss";

const RoConfiguration = ({
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  setStageValidationSucessfull,
  noOfTrains,
  RONFElements,
  setMandatoryComponentsStatus,
}) => {
  const { t } = useTranslation();
  const [trainobj, setTrainObj] = useState(trains);
  const [traintabs, setTraintabs] = useState([]);
  const [selectedTrain, setSelectedTrain] = useState(0);
  const [selectedTrainPage, setSelectedTrainPage] = useState(null);
  const [isNonDuPontElement, setIsNonDuPontElement] = useState(false);
  const isInitialLoadRef = React.useRef(true);

  const markAsChanged = () => {
    if (setMandatoryComponentsStatus) {
      setMandatoryComponentsStatus((prev) => ({
        ...prev,
        roConfiguration: { ...prev.roConfiguration, changed: true },
      }));
    }
  };

  useEffect(() => {
    if (trains && Object.keys(trains).length >= 1) {
      setTrainObj(Object.values(trains));
    }
  }, [trains, t]);

  useEffect(() => {
    if (trains !== undefined && Object.keys(trains).length > 0) {
      setIsNonDuPontElement(!trains[selectedTrain]?.is_dupont_element);
    }
  }, [selectedTrain]);

  useEffect(() => {
    const tabs = [];
    if (noOfTrains === "" || noOfTrains === undefined || noOfTrains === "0") {
      return;
    }

    if (trainobj.length > noOfTrains) {
      for (let i = trainobj.length; i > noOfTrains; i--) {
        trainobj.pop(i - 1);
      }
    }
    var start = trainobj === undefined ? 0 : Object.keys(trainobj).length;
    for (let i = start + 1; i <= parseInt(noOfTrains); i++) {
      const newTrain = {
        train_id: i,
        passes: [{ pass_id: 1, stages: [{ stage_id: 1 }] }],
        is_dupont_element: true,
      };
      trainobj.push(newTrain);
    }

    for (let i = 1; i <= parseInt(noOfTrains); i++) {
      tabs.push({
        label: `${t("ValueStrings.train")} ${i}`,
        tabval: `${t("ValueStrings.train")} ${i}`,
        page: (
          <PassComponent
            train_id={i}
            t={t}
            trains={trainobj}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
            isNonDuPontElement={isNonDuPontElement}
            RONFElements={RONFElements}
            markAsChanged={markAsChanged}
          />
        ),
      });
    }
    setTrains({ ...trainobj });
    setTraintabs(tabs);
    if (tabs && tabs.length && tabs.length > selectedTrain) {
      setSelectedTrainPage(tabs[selectedTrain]?.page);
    } else {
      setSelectedTrain(0);
      setSelectedTrainPage(tabs[0]?.page);
    }
  }, [noOfTrains, trainobj, stageValidationSucessfull, t]);

  const resetRONFElementUsedFields = (updatedTrains, trainIdToReset) => {
    const newTrainObj = [...(updatedTrains || trainobj)];
    if (trainIdToReset !== undefined) {
      const train = newTrainObj[trainIdToReset];
      if (train) {
        train.passes.forEach((pass) => {
          pass.stages.forEach((stage) => {
            stage.ro_nf_element_used = undefined;
          });
        });
      }
    } else {
      newTrainObj.forEach((train) => {
        train.passes.forEach((pass) => {
          pass.stages.forEach((stage) => {
            stage.ro_nf_element_used = undefined;
          });
        });
      });
    }
    setTrains({ ...newTrainObj });
  };

  useEffect(() => {
    if (RONFElements.length > 0 && isNonDuPontElement === false) {
      if (isInitialLoadRef.current) {
        isInitialLoadRef.current = false;
        return;
      }
      // empty ro_nf_element_used field only on RONFElements change (not initial load)
      resetRONFElementUsedFields();
    }
  }, [RONFElements]);

  const onTrainTabSelected = (value) => {
    setSelectedTrainPage(traintabs[value].page);
    setSelectedTrain(value);
  };

  const handleIsNonDuPontElementChange = (isNonDuPont) => {
    setIsNonDuPontElement(isNonDuPont);
    const updatedTrains = trainobj.map((train, idx) =>
      idx === selectedTrain
        ? { ...train, is_dupont_element: !isNonDuPont }
        : train,
    );
    resetRONFElementUsedFields(updatedTrains, selectedTrain);
    markAsChanged();
  };

  return (
    <>
      {/*Removed Number of trains input box - can be used when editing trains functionality introduces */}
      {/* <div className="flex-between outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfTrains")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <InputBox
          id="no-of-trains"
          name="trains"
          value={noOfTrains}
          customClass="custom-input-width "
          placeholder={t("addNewPlant.noOfTrains")}
          disabled
          hideClearBtn
        />
      </div> */}
      {traintabs && (
        <>
          <div className="horizontal-scroll-container">
            <div className="horizontal-scroll">
              <CustomTabs
                tabOptions={traintabs}
                tabChangeHandler={onTrainTabSelected}
                value={selectedTrain}
              />
            </div>
          </div>
          <DupontCheckbox
            labelText={t("addNewPlant.nonDupontElement")}
            checked={isNonDuPontElement}
            onChange={handleIsNonDuPontElementChange}
            customClass="non-dupont-checkbox"
          />
          <div>{selectedTrainPage}</div>
        </>
      )}
    </>
  );
};

export default RoConfiguration;

const passOptions = () => {
  return ["1", "2", "3"];
};
export const PassComponent = ({
  train_id,
  t,
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  setStageValidationSucessfull,
  isNonDuPontElement,
  RONFElements,
  markAsChanged,
}) => {
  const passOption = passOptions();
  train_id -= 1;
  const [pass, setPass] = useState(trains[train_id].passes.length);
  const [passtabs, setPasstabs] = useState([]);
  const [selectedPass, setSelectedPass] = useState(0);
  const [selectedPassPage, setSelectedPassPage] = useState(null);

  const passNo =
    trains[train_id]?.passes?.length <= 0
      ? 1
      : trains[train_id]?.passes?.length;

  useEffect(() => {
    setPass(trains[train_id].passes.length);
  }, [trains[train_id].passes.length, t]);

  useEffect(() => {
    if (trains && trains[train_id].passes.length >= 1) {
      setPass(trains[train_id].passes.length);
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    for (let i = 1; i <= passNo; i++) {
      tabs.push({
        label: `${t("addNewPlant.pass")} ${i}`,
        tabval: `${t("addNewPlant.pass")} ${i}`,
        page: (
          <StageComponent
            train_id={train_id}
            pass_id={i}
            t={t}
            trains={trains}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
            isNonDuPontElement={isNonDuPontElement}
            RONFElements={RONFElements}
            markAsChanged={markAsChanged}
          />
        ),
      });
    }
    setPasstabs(tabs);

    if (tabs && tabs.length > 0 && tabs[selectedPass]) {
      setSelectedPassPage(tabs[selectedPass].page);
    } else {
      setSelectedPassPage(tabs[0].page);
      setSelectedPass(0);
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    for (let i = 1; i <= passNo; i++) {
      tabs.push({
        label: `${t("addNewPlant.pass")} ${i}`,
        tabval: `${t("addNewPlant.pass")} ${i}`,
        page: (
          <StageComponent
            train_id={train_id}
            pass_id={i}
            t={t}
            trains={trains}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
            isNonDuPontElement={isNonDuPontElement}
            RONFElements={RONFElements}
          />
        ),
      });
    }

    setPasstabs(tabs);

    if (tabs && tabs.length > 0 && tabs[selectedPass]) {
      setSelectedPassPage(tabs[selectedPass].page);
    } else {
      setSelectedPassPage(tabs[0].page);
      setSelectedPass(0);
    }
  }, [pass, passNo, stageValidationSucessfull, t]);

  const onPassChanged = (value) => {
    var start = trains[train_id]?.passes?.length;
    start = start ? start : 1;

    if (start > value) {
      for (let i = start; i > value; i--) {
        trains[train_id].passes.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(value); i++) {
      const newPass = {
        pass_id: i,
        stages: [
          {
            stage_id: 1,
          },
        ],
      };
      trains[train_id].passes.push(newPass);
    }
    setPass(value);
    markAsChanged();
    setTrains({ ...trains });
  };
  const onPassTabSelected = (value) => {
    setSelectedPassPage(passtabs[value].page);
    setSelectedPass(value);
  };

  return (
    <>
      <div className="flex-between outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfPass")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <div className="custom-input-width">
          <Dropdown
            id="no-of-passes"
            placeholder={t("addNewPlant.pass")}
            value={passNo.toString()}
            onChange={(value) => onPassChanged(value)}
            options={passOption}
          />
        </div>
      </div>
      {passtabs && (
        <>
          <CustomTabs
            tabOptions={passtabs}
            tabChangeHandler={onPassTabSelected}
            value={selectedPass}
          />
          <div>{selectedPassPage}</div>
        </>
      )}
    </>
  );
};

const stageOptions = () => {
  return ["1", "2", "3"];
};

export const StageComponent = ({
  train_id,
  pass_id,
  t,
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  isNonDuPontElement,
  RONFElements,
  markAsChanged,
}) => {
  const stageOption = stageOptions();
  const pass_id_index = pass_id - 1;
  const passIdValue = pass_id;
  const [stage, setStage] = useState(
    trains[train_id].passes[pass_id_index].stages.length,
  );

  const [inputVal, setInputVal] = useState([]);
  const [showISDModal, setShowISDModal] = useState([]);
  const stageNo =
    trains[train_id]?.passes[pass_id_index]?.stages?.length <= 0
      ? 1
      : trains[train_id]?.passes[pass_id_index]?.stages?.length;

  useEffect(() => {
    if (Array.isArray(trains)) {
      setInputVal([...trains]);
      setTotalNumberOfElements(getTotalNumber(trains));
    }
  }, [trains, t]);

  useEffect(() => {
    var start = trains[train_id]?.passes[pass_id_index]?.stages?.length;
    start = start ? start : 1;

    if (start > parseInt(stageNo)) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.passes[pass_id_index]?.stages.pop(i - 1);
      }
    }
    for (let i = start; i <= parseInt(stageNo); i++) {
      trains[train_id].passes[pass_id_index].stages.push({ stage_id: i });
    }
    setTrains({ ...trains });
    setShowISDModal((prev) => {
      const arr = Array(parseInt(stageNo)).fill(false);
      if (prev && Array.isArray(prev)) {
        for (let i = 0; i < arr.length && i < prev.length; i++) {
          arr[i] = prev[i];
        }
      }
      return arr;
    });
  }, []);

  useEffect(() => {
    var start = trains[train_id]?.passes[pass_id_index]?.stages?.length;
    start = start ? start : 1;

    if (start > stageNo) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.passes[pass_id_index]?.stages.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(stageNo); i++) {
      trains[train_id].passes[pass_id_index].stages.push({ stage_id: i });
    }
    setTrains({ ...trains });
  }, [stage, stageNo, t]);

  const onStageChanged = (id, value) => {
    var start = trains[train_id]?.passes[pass_id_index]?.stages?.length;
    start = start ? start : 1;

    if (start > value) {
      for (let i = start; i > value; i--) {
        trains[train_id]?.passes[pass_id_index]?.stages.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(value); i++) {
      trains[train_id].passes[pass_id_index].stages.push({ stage_id: i });
    }

    markAsChanged();
    setTrains({ ...trains });
    setStage(value);
  };

  const onStageInputChanged = (stageId, value, name) => {
    if (name === "installation_year") {
      value = value ? moment(value).format("YYYY-MM-DD") : "";
    }
    const trainId = train_id + 1;
    const trainIndex = trains.findIndex(
      (trainItem) => trainItem.train_id === trainId,
    );

    if (trainIndex !== -1) {
      const passIndex = trains[trainIndex].passes.findIndex(
        (passItem) => passItem.pass_id === passIdValue,
      );
      if (passIndex !== -1) {
        const prevStage =
          trains[trainIndex].passes[passIndex].stages[stageId] || {};
        let is_isd = prevStage.is_isd;

        if (name === "is_isd") {
          is_isd = value === "isd";
        }

        const updatedStage = {
          ...prevStage,
          [name]: value,
          is_isd,
        };

        if (name === "num_element_per_pressure_vessel" && prevStage.is_isd) {
          const oldCount = prevStage.num_element_per_pressure_vessel;
          const newCount = value;
          if (
            oldCount !== newCount &&
            Array.isArray(prevStage.ro_nf_element_used)
          ) {
            updatedStage.ro_nf_element_used = [];
          }
        }

        trains[trainIndex].passes[passIndex].stages[stageId] = updatedStage;
      }
    }
    markAsChanged();
    setTrains({ ...trains });
    setInputVal({ ...trains });

    setTotalNumberOfElements(getTotalNumber(trains));
  };

  const getInputVal = (key, index) => {
    if (
      Object.keys(inputVal).length > 0 &&
      inputVal[train_id] &&
      inputVal[train_id].passes[pass_id_index]
    ) {
      const id = inputVal[train_id].passes[pass_id_index].stages[index];
      return id && id[key] ? id[key] : "";
    } else return "";
  };

  const getTotalNumber = (trains) => {
    const stageValue = [];

    for (const train of trains) {
      for (const pass of train.passes) {
        for (const stage of pass.stages) {
          if (
            stage.num_pressure_vessels === undefined ||
            stage.num_element_per_pressure_vessel === undefined
          ) {
            const { NUM_PRESSURE_VESSELS, NUM_ELEMENTS_PER_PV } =
              STAGE_DEFAULTS;

            stage.num_pressure_vessels = NUM_PRESSURE_VESSELS;
            stage.num_element_per_pressure_vessel = NUM_ELEMENTS_PER_PV;
            stageValue.push({
              num_pressure_vessels: stage.num_pressure_vessels,
              num_element_per_pressure_vessel:
                stage.num_element_per_pressure_vessel,
            });
          } else {
            stageValue.push({
              num_pressure_vessels: stage.num_pressure_vessels,
              num_element_per_pressure_vessel:
                stage.num_element_per_pressure_vessel,
            });
          }
        }
      }
    }
    return calculateCumulativeSum(stageValue);
  };
  const calculateCumulativeSum = (data) => {
    let cumulativeSum = 0;
    for (const element of data) {
      const numPressureVessels = parseInt(element.num_pressure_vessels);
      const numElementPerPressureVessel = parseInt(
        element.num_element_per_pressure_vessel,
      );
      const product = numPressureVessels * numElementPerPressureVessel;
      cumulativeSum += product;
    }
    const sum = isNaN(cumulativeSum) ? "" : cumulativeSum;
    return sum;
  };
  const getErrors = (key, index) => {
    if (
      !stageValidationSucessfull &&
      (trains[train_id].passes[pass_id_index].stages[index] === undefined ||
        trains[train_id].passes[pass_id_index].stages[index][key] ===
          undefined ||
        trains[train_id].passes[pass_id_index].stages[index][key] === "")
    ) {
      return true;
    }
  };

  return (
    <>
      <div className="flex-between description-text outline-box no-bottom-border">
        <span className="description-text">
          {t("addNewPlant.noOfstage")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <div className="custom-input-width">
          <Dropdown
            id="no-of-stages"
            placeholder={t("addNewPlant.stage")}
            value={stageNo.toString()}
            onChange={(value) => onStageChanged(pass_id, value)}
            options={stageOption}
          />
        </div>
      </div>
      <div className="flex-between outline-box stage-container no-top-radius">
        <div className=" description-text marginTop30 ">
          <div className="padding-top-20">
            {t("addNewPlant.noOfVessels")}{" "}
            <span style={{ color: "red" }}> *</span>
          </div>
          <div className="padding-top-20">
            {t("addNewPlant.noOfElementsVessels")}
            <span style={{ color: "red" }}> *</span>
          </div>
          <div className="label-align-with-radio">
            {t("addNewPlant.ro/nfElements")}{" "}
            <span style={{ color: "red" }}> *</span>
          </div>
          <div className="padding-top-30">
            {t("addNewPlant.installationYear")}
          </div>
        </div>
        <div className="flex-between">
          {Array.from({
            length: trains[train_id].passes[pass_id_index].stages.length,
          }).map((_, index) => (
            <div className="margin-left-stage stage-Input">
              <div className="teal-text marginBtm20">{`${t(
                "addNewPlant.stage",
              )} ${index + 1}`}</div>
              <div>
                <InputBox
                  key={`${pass_id}num_pressure_vessels${index}`}
                  name="num_pressure_vessels"
                  value={getInputVal("num_pressure_vessels", index)}
                  placeholder={t("addNewPlant.noOfVessels")}
                  onChange={(value, name) =>
                    onStageInputChanged(index, value, name)
                  }
                  validator={TextFieldValidator.NUMBER_ONLY}
                  maxLength={6}
                  errorMsg={
                    getErrors("num_pressure_vessels", index) ||
                    (getInputVal("num_pressure_vessels", index) < 1 ||
                    getInputVal("num_pressure_vessels", index) > 100000
                      ? t("addNewPlant.noofPressureVesselsValidation")
                      : "")
                  }
                />
                <InputBox
                  key={`${pass_id}num_element_per_pressure_vessel ${index}`}
                  name="num_element_per_pressure_vessel"
                  value={getInputVal("num_element_per_pressure_vessel", index)}
                  customClass="padding-top-10"
                  placeholder={t("addNewPlant.noOfElementsVesselsPlaceholder")}
                  onChange={(value, name) =>
                    onStageInputChanged(index, value, name)
                  }
                  validator={TextFieldValidator.NUMBER_ONLY}
                  maxLength={3}
                  errorMsg={
                    getErrors("num_element_per_pressure_vessel", index) ||
                    (getInputVal("num_element_per_pressure_vessel", index) <
                      1 ||
                    getInputVal("num_element_per_pressure_vessel", index) > 8
                      ? t("addNewPlant.elementsPerVesselValidation")
                      : "")
                  }
                />

                {isNonDuPontElement ? (
                  <WPInput
                    key={`${pass_id}ro_nf_element_used${index}`}
                    name="ro_nf_element_used"
                    value={getInputVal("ro_nf_element_used", index)}
                    placeholder={t("addNewPlant.ro/nfElements")}
                    onChange={(e) => {
                      onStageInputChanged(
                        index,
                        e.target.value,
                        "ro_nf_element_used",
                      );
                    }}
                    customValidation={(value) => value !== " "}
                    requiredMsg={
                      stageValidationSucessfull === false &&
                      !getInputVal("ro_nf_element_used", index)
                    }
                  />
                ) : (
                  <>
                    <div
                      className="element-type-radio"
                      onChange={(e) => {
                        const value = e.target.value;
                        const trainId = train_id + 1;
                        const trainIndex = trains.findIndex(
                          (trainItem) => trainItem.train_id === trainId,
                        );
                        if (trainIndex !== -1) {
                          const passIndex = trains[trainIndex].passes.findIndex(
                            (passItem) => passItem.pass_id === passIdValue,
                          );
                          if (passIndex !== -1) {
                            let updatedStage = {
                              ...trains[trainIndex].passes[passIndex].stages[
                                index
                              ],
                              is_isd: value === "isd",
                            };
                            if (value === "isd") {
                              updatedStage.ro_nf_element_used = [];
                            } else {
                              updatedStage.ro_nf_element_used = "";
                            }
                            trains[trainIndex].passes[passIndex].stages[index] =
                              updatedStage;
                          }
                        }
                        markAsChanged();
                        setTrains({ ...trains });
                        setInputVal({ ...trains });
                      }}
                    >
                      <DupontRadio
                        text={t("addNewPlant.single")}
                        value="single"
                        name={`stage-type-${pass_id}-${index}`}
                        checked={getInputVal("is_isd", index) !== true}
                      />
                      <DupontRadio
                        text={TECHNOLOGIES.ISD}
                        value="isd"
                        name={`stage-type-${pass_id}-${index}`}
                        checked={getInputVal("is_isd", index) === true}
                      />
                    </div>
                    {getInputVal("is_isd", index) === true ? (
                      <>
                        <WPTertiaryButton
                          label={t("addNewPlant.editISD")}
                          variant="outlined"
                          disabled={
                            !getInputVal(
                              "num_element_per_pressure_vessel",
                              index,
                            ) ||
                            isNaN(
                              Number(
                                getInputVal(
                                  "num_element_per_pressure_vessel",
                                  index,
                                ),
                              ),
                            ) ||
                            Number(
                              getInputVal(
                                "num_element_per_pressure_vessel",
                                index,
                              ),
                            ) < 1 ||
                            Number(
                              getInputVal(
                                "num_element_per_pressure_vessel",
                                index,
                              ),
                            ) > 8
                          }
                          onClick={() => {
                            setShowISDModal((prev) => {
                              const newState = [...(showISDModal || [])];
                              newState[index] = true;
                              return newState;
                            });
                          }}
                          className="stage-Input btn-full-width"
                        />

                        {showISDModal &&
                          showISDModal[index] &&
                          (() => {
                            if (!window._elementDialogRefs)
                              window._elementDialogRefs = {};
                            if (!window._elementDialogRefs[index]) {
                              window._elementDialogRefs[index] =
                                React.createRef();
                            }
                            const elementDialogRef =
                              window._elementDialogRefs[index];
                            return (
                              <CustomModal
                                header={t("addNewPlant.internalStageDesign")}
                                show={true}
                                confirmBtn={t("ValueStrings.confirm")}
                                size="small"
                                confirmBtnDisabled={
                                  !(
                                    elementDialogRef.current &&
                                    elementDialogRef.current.allSelected
                                  )
                                }
                                isLoading={window.__isdModalLoading}
                                onModalClose={async ({ target }) => {
                                  if (target.id === "modal-confirm-btn") {
                                    if (
                                      elementDialogRef.current &&
                                      elementDialogRef.current.allSelected
                                    ) {
                                      const elements =
                                        elementDialogRef.current.elements;
                                      trains[train_id].passes[
                                        pass_id_index
                                      ].stages[index].ro_nf_element_used =
                                        elements;
                                      markAsChanged();
                                      setTrains([...trains]);
                                      try {
                                        window.__isdModalLoading = true;
                                        const params = new URLSearchParams(
                                          window.location.search,
                                        );
                                        const isEdit = params.get("isEdit");
                                        if (
                                          isEdit === "true" &&
                                          typeof window.savePlantDetails ===
                                            "function"
                                        ) {
                                          await window.savePlantDetails(
                                            "continue",
                                            {
                                              skipNavigate: true,
                                              skipLoading: true,
                                            },
                                          );
                                        }
                                      } finally {
                                        window.__isdModalLoading = false;
                                      }
                                    }
                                  }
                                  setShowISDModal((prev) => {
                                    const newState = [...(showISDModal || [])];
                                    newState[index] = false;
                                    return newState;
                                  });
                                }}
                              >
                                <ElementSelectionDialog
                                  ref={elementDialogRef}
                                  numElements={
                                    trains[train_id]?.passes[pass_id_index]
                                      ?.stages[index]
                                      ?.num_element_per_pressure_vessel || 1
                                  }
                                  elementOptions={RONFElements.map(
                                    (opt) => opt.value,
                                  )}
                                  initialValues={
                                    trains[train_id]?.passes[pass_id_index]
                                      ?.stages[index]?.ro_nf_element_used || []
                                  }
                                />
                              </CustomModal>
                            );
                          })()}
                      </>
                    ) : (
                      <WPDropdown
                        key={`${pass_id}ro_nf_element_used${index}`}
                        name="ro_nf_element_used"
                        value={getInputVal("ro_nf_element_used", index)}
                        placeholder={t("addNewPlant.ro/nfElements")}
                        onChange={(selectedOption) =>
                          onStageInputChanged(
                            index,
                            // Always send string for single element
                            selectedOption?.value || "",
                            "ro_nf_element_used",
                          )
                        }
                        options={RONFElements}
                      />
                    )}
                  </>
                )}

                <div className="padding-top-10">
                  <DupontDatePicker
                    id={`${pass_id}installation_year${index}`}
                    selected={
                      getInputVal("installation_year", index) !== ""
                        ? new Date(getInputVal("installation_year", index))
                        : ""
                    }
                    dateFormat={t("ValueStrings.DATE_FORMAT_SMALL")}
                    onChange={(value, name) =>
                      onStageInputChanged(index, value, "installation_year")
                    }
                    startDate={new Date()}
                    maxDate={new Date()}
                    className={"width-fill "}
                    placeholderText={t("ValueStrings.selectDate")}
                    {...DatePickerConfig}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
